module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/3@2x_c98d5923425a1bef72e744f0ec4f60f6.png";